import config from "../config";

export const BASEURL_POLYMER  = config.isLocalhost ? '' : process.env.REACT_APP_API_DEV_BASE_URL;

export const SUB_PATH_BASIC = config.isLocalhost ? '' : '/polymer';
export const SUB_PATH_UPLOAD = config.isLocalhost ? '' : "/polymer";


//Below : Currently is using Swagger;


export const APPLICATION_DETAIL_ENDPOINT        = `/applicationDetail`;
export const APPLICATION_DOWNLOAD_FILE_ENDPOINT = `/file/download`;

export const API_MyInfo                         = `${BASEURL_POLYMER}/myinfo`;
export const API_Mock_MyInfo                    = `${BASEURL_POLYMER}${SUB_PATH_BASIC}/mockmyinfo`;
export const API_UserInfo                       = `${BASEURL_POLYMER}/userinfo`;
export const API_RenewToken                     = `${BASEURL_POLYMER}/renew`;
export const API_MyInfo_AccessToken             = `${BASEURL_POLYMER}/myinfobyaccesstoken`;
export const API_Spcp_AccessToken               = `${BASEURL_POLYMER}/spcpbyaccesstoken`;

export const API_HLEStatus                      = `${BASEURL_POLYMER}${SUB_PATH_BASIC}/application/checkHleApproval`;
export const API_CheckEligibility               = `${BASEURL_POLYMER}${SUB_PATH_BASIC}/application/checkEligibility`;
export const API_DraftDetail                    = `${BASEURL_POLYMER}${SUB_PATH_BASIC}/applicationDraftDetail`;
export const API_ApplicationDetail              = `${BASEURL_POLYMER}${SUB_PATH_BASIC}${APPLICATION_DETAIL_ENDPOINT}`;
export const API_ApplicationDelete              = `${BASEURL_POLYMER}${SUB_PATH_BASIC}/application/delete`;
export const API_ApplicationRemove              = `${BASEURL_POLYMER}${SUB_PATH_BASIC}/application/remove`;
export const API_CheckApplicationConsent        = `${BASEURL_POLYMER}${SUB_PATH_BASIC}/checkApplicationConsent`;
export const API_ApplicationSaveDraft           = `${BASEURL_POLYMER}${SUB_PATH_BASIC}/application/saveDraft`;
export const API_ApplicationSubmit              = `${BASEURL_POLYMER}${SUB_PATH_BASIC}/file/application/submit`;
export const API_StartConsent                   = `${BASEURL_POLYMER}${SUB_PATH_BASIC}/startConsent`;
export const API_GiveConsent                    = `${BASEURL_POLYMER}${SUB_PATH_BASIC}/giveConsent`;
export const API_CompleteConsent                = `${BASEURL_POLYMER}${SUB_PATH_BASIC}/completeConsent`;
export const API_CheckPersonRecords             = `${BASEURL_POLYMER}${SUB_PATH_BASIC}/api/v1/hdb/cdb/check-person-records`;


export const API_ApplicationReply               = `${BASEURL_POLYMER}${SUB_PATH_BASIC}/application/applicationReply`;
export const API_ApplicationStageUpdate         = `${BASEURL_POLYMER}${SUB_PATH_BASIC}/application/polymerStageUpdate`;
export const API_SolicitorUpdate                = `${BASEURL_POLYMER}${SUB_PATH_BASIC}/application/solicitorUpdate`;
export const API_MOPCheck                       = `${BASEURL_POLYMER}${SUB_PATH_BASIC}/mopCheck`;
export const API_DocumentSave                   = `${BASEURL_POLYMER}${SUB_PATH_BASIC}/document/save`;

export const API_ApplicationPayment             = `${BASEURL_POLYMER}${SUB_PATH_BASIC}/application/payment`;
export const API_ApplicationProcessPayment      = `${BASEURL_POLYMER}${SUB_PATH_BASIC}/application/processPayment`;
export const API_ApplicationCreditNotification  = `${BASEURL_POLYMER}${SUB_PATH_BASIC}/api/v1/payment/credit_notification`;
export const API_PaymentSuccess                 = `${BASEURL_POLYMER}${SUB_PATH_BASIC}/payment-success`;

export const API_UpdateNotification             = `${BASEURL_POLYMER}${SUB_PATH_BASIC}/application/notification`;
export const API_DebarmentStatus                = `${BASEURL_POLYMER}${SUB_PATH_BASIC}/api/v1/hdb/deb/debarment`;
export const API_GetLoanStatus                  = `${BASEURL_POLYMER}${SUB_PATH_BASIC}/getLoanStatus`;

export const API_UploadFile_V2                  = `${BASEURL_POLYMER}${SUB_PATH_UPLOAD}/file/base/uploadDraft`;
export const API_UploadFileWithUuid_V2          = `${BASEURL_POLYMER}${SUB_PATH_UPLOAD}/file/base/upload`;
export const API_DownloadFile                   = `${BASEURL_POLYMER}${SUB_PATH_UPLOAD}${APPLICATION_DOWNLOAD_FILE_ENDPOINT}`;

export const API_EstimatedFees                  = `${BASEURL_POLYMER}${SUB_PATH_BASIC}/fee/configuration`
export const API_PurgedData                     = `${BASEURL_POLYMER}${SUB_PATH_BASIC}/application/purgeByUinfin`
export const API_PurgedAllData                  = `${BASEURL_POLYMER}${SUB_PATH_BASIC}/application/purge`

export const API_EligibilityDebugLog                = `${BASEURL_POLYMER}${SUB_PATH_BASIC}/application/checkEligibility/FEDebugLog`;

//Query
export const APPLICATION_INITIATED_QUERY        = `${SUB_PATH_BASIC}/application/checkApplicationHDBRefExisted`;

export const API_OverrideEligibilityCheck       = `${BASEURL_POLYMER}${SUB_PATH_BASIC}/override-eligibility-check`;
